<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <RibbonForm :station-id="stationId" :table-url="tableUrl"></RibbonForm>
    </div>
  </div>
</template>

<script setup>
import TheHeader from "@/components/layouts/TheHeader.vue";
import RibbonForm from "@/components/ribbon/RibbonForm.vue";
import { onMounted } from "vue";

const stationId = 57;
const viewName = "Ribbon";
const tableUrl = `/Material/GetLastMaterilRibbons?num=15`;

onMounted(() => {
  document.title = viewName;
});
</script>
